import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const Header = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-black/95 backdrop-blur-sm border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-12 lg:px-20">
        <div className="flex items-center justify-between h-20 md:h-24">
          <a href="/" data-testid="logo-link" className="flex items-center">
            <img src="/logo.png" alt="Harlem Leads" className="h-20 md:h-20 w-auto rounded-sm" />
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("approach")}
              data-testid="nav-approach"
              className="nav-link text-white/40 hover:text-white text-sm"
            >
              Approach
            </button>
            <button
              onClick={() => scrollToSection("industries")}
              data-testid="nav-industries"
              className="nav-link text-white/40 hover:text-white text-sm"
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection("process")}
              data-testid="nav-process"
              className="nav-link text-white/40 hover:text-white text-sm"
            >
              Process
            </button>
          </nav>

          <div className="flex items-center gap-4">
            <Button
              onClick={onContactClick}
              data-testid="header-cta-btn"
              className="premium-btn bg-[#6DBE2E] text-black hover:bg-[#5CAD25] rounded-none font-semibold px-4 md:px-5 py-2 text-sm"
            >
              Get in Touch
            </Button>
            
            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-white p-1"
              data-testid="mobile-menu-btn"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-white/5">
          <div className="px-5 py-4 space-y-4">
            <button
              onClick={() => scrollToSection("approach")}
              className="block text-white/60 hover:text-white text-sm w-full text-left py-2"
            >
              Approach
            </button>
            <button
              onClick={() => scrollToSection("industries")}
              className="block text-white/60 hover:text-white text-sm w-full text-left py-2"
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection("process")}
              className="block text-white/60 hover:text-white text-sm w-full text-left py-2"
            >
              Process
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
